import { propTypes } from "react-bootstrap/esm/Image";
import { Link, useNavigate } from "react-router-dom";
import CButton from "../../../../../components/buttons/Button";

const SuccessOtp = (props) => {

  const navigate = useNavigate();

  const setSuccess = () => {
    props.setOtp(true);
    navigate ("/login/forgot-password");
  };

  return (
    <>
      <div className="row py-5">
        <div className="col-md-4 col-sm-12"></div>
        <div className="col-md-4 col-sm-12 text-center mt-5" style={{minHeight:"100vh"}}>
          <span className="text-dark mt-5 mb-5 fw-bolder">
          Your Email has been
          </span>
          <br></br>
          <span className="text-dark mb-5 fw-bolder"> successfully verified.</span>
          <CButton
            btnClassesDiv={"text-center mt-5"}
            btnClasses={"btn px-4 fw-bold text-white mt-5"}
            IsOutline={false}
            innertext={"Done"}
            btnCustomStyle={{
              backgroundColor: "#044389",
            }}
            functionName={() => setSuccess()}
          />
        </div>
        <div className="col-md-4 col-sm-12"></div>
      </div>
    </>
  );
};

export default SuccessOtp;
